<template>
    <div class="full-width" ref="record14ListDom" v-loading="loading">
        <el-row :gutter="20" style="margin: 0">
            <el-col class="el-col-my" :span="contentSpan" v-for="(v, i) in recordList" :key="v.id">
                <record14Record :obj="v" @clickAdd="clickAddBtn" />
            </el-col>
        </el-row>

        <paginationComponent :pageObj="pageObj" @goPage="changePage" />
    </div>
</template>

<script setup>
    import record14Record from "@/components/shopopee/hall/record14Record"
    import paginationComponent from "@/components/shopopee/common/paginationComponent"
    import {getCurrentInstance, inject, onMounted, ref, onBeforeMount} from "vue";
    import record15Api from "@/request/record15Api";
    import myUtil from "@/util/util";

    const i18n = inject("i18n")

    const props = defineProps(["type"])
    const emits = defineEmits(["clickAdd"])

    const { proxy } = getCurrentInstance()
    const width = ref(425)

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const shopCompany = ref({})
    const loading = ref(false)

    const pageObj = ref({})
    const recordList = ref([])
    const contentSpan = ref(24)
    const queryType = ref(0)

    let pageNum = 1
    let pageSize = 10

    function getRecordList(){
        loading.value = true
        const request = record15Api.queryRecord14CompanyModelByPage
        const params = request.getParams()

        params.companycode = shopCompany.value.companycode
        params.addinfo17 = queryType.value
        params.pageNum = pageNum
        params.pageSize = pageSize

        request.send(params, fillRecordInfo)

    }

    function fillRecordInfo(res){
        loading.value = false
        if (res.code == 200){
            const obj = res.detail
            pageObj.value = obj
            recordList.value = obj.list
        }else{
            myUtil.alertError(res.msg)
        }
    }

    function changePage(num){
        pageNum = num

        getRecordList()
    }

    function clickAddBtn(v){
        emits("clickAdd", v)
    }

    onBeforeMount(() => {
        if (null != props.type){
            queryType.value = props.type
        }
    })

    onMounted(() => {
        width.value = proxy.$refs.record14ListDom.offsetWidth

        if (width.value > 768){
            contentSpan.value = 12
        }else if (width.value > 1280){
            contentSpan.value = 6
        }

        shopCompany.value = getShopCompanyObj()
        getRecordList()

    })
</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .el-col-my {
        margin-bottom: 10px;
        margin-top: 10px;
    }
</style>